import { Grid, Skeleton } from '@mui/material';
import { CerebroDrawer, CerebroHeading, CerebroText } from '../../../shared/components';
import { useDataRoomUserOptOutDetailsQuery } from '../../../shared/hooks';
import { DataRoomUser } from '../../../shared/models';

interface OptOutDetailsProps {
	dataRoomGuid: string | undefined;
	user: DataRoomUser | null;
	close: () => void;
}

export const OptOutDetails: React.FC<OptOutDetailsProps> = ({ dataRoomGuid, user, close }) => {
	const optOutQuery = useDataRoomUserOptOutDetailsQuery(dataRoomGuid, user?.guid, {
		enabled: user != null,
		retry: false,
	});

	return (
		<CerebroDrawer open={user != null} onClose={() => close()} PaperProps={{ sx: { width: '500px' } }}>
			<CerebroHeading size="h1" gutterBottom sx={{ marginBottom: 3 }}>
				{user?.firstName} {user?.lastName} ({user?.bankName})
			</CerebroHeading>

			{optOutQuery.isLoading && (
				<>
					<Skeleton height={60} />
					<Skeleton height={60} />
					<Skeleton height={60} />
				</>
			)}

			{optOutQuery.isSuccess && (
				<>
					{optOutQuery.data.reasons && optOutQuery.data.reasons.length > 0 && (
						<Grid container sx={{ marginBottom: 3 }}>
							<Grid item xs={12}>
								<CerebroText sx={{ fontWeight: 'bold' }}>Reasons</CerebroText>
							</Grid>
							{optOutQuery.data.reasons.map(reason => {
								return (
									<Grid key={'reason' + reason.id} item xs={12}>
										<CerebroText>{reason.name}</CerebroText>
									</Grid>
								);
							})}
						</Grid>
					)}

					{optOutQuery.data.otherReason && (
						<Grid container sx={{ marginBottom: 3 }}>
							<Grid item xs={12}>
								<CerebroText sx={{ fontWeight: 'bold' }}>Other Reason</CerebroText>
							</Grid>
							<Grid item xs={12}>
								<CerebroText>{optOutQuery.data.otherReason}</CerebroText>
							</Grid>
						</Grid>
					)}

					<Grid container sx={{ marginBottom: 3 }}>
						<Grid item xs={12}>
							<CerebroText sx={{ fontWeight: 'bold' }}>Details</CerebroText>
						</Grid>
						<Grid item xs={12}>
							<CerebroText>{optOutQuery.data.detail}</CerebroText>
						</Grid>
					</Grid>
				</>
			)}
		</CerebroDrawer>
	);
};
